(function () {
  'use strict';

  /* @ngdoc object
   * @name home.matches
   * @description
   *
   */
  angular
    .module('neo.home.resultats', [
      'ui.router','neo.home.votacio'
    ]);
}());
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


